// general imports
import { IconPropsType } from '../types'

const DropdownIcon = ({ className }: IconPropsType) => {
  return (
    <svg
      className={className}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M11.06 5.53027L8 8.58361L4.94 5.53027L4 6.47027L8 10.4703L12 6.47027L11.06 5.53027Z'
        fill='#191C1F'
      />
    </svg>
  )
}

export default DropdownIcon
